import {Component, OnInit,Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

export interface DialogData {
  animal: string;
  name: string;
}
export interface camp {
  last_name: string;
  date_of_birth:  string;
  Patient:  number;
  first_name: string;
  protein:  number;
  city : string;
  phoneno : string;
  email: string;
 
}


@Component({
  selector: 'Campdialog-modal',
  templateUrl: 'Campdialog.component.html',
})

export class CampDialogComponent {
  index: number;
	 // MatPaginator Inputs
  length = 100;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  checked = false;

    // MatPaginator Output
  pageEvent: PageEvent;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }
  desserts2: camp[] = [
    {first_name: 'Jhon ', last_name: 'Shinah', Patient: 6, date_of_birth: '24-03-2019', protein: 4, city : "Surat", phoneno : "123456789" , email : "test@test.com"},
    {first_name: 'Robort', last_name: 'Pitter', Patient: 9, date_of_birth: '24-03-2019', protein: 4, city : "Surat", phoneno : "123456789" , email : "test@test.com"},
    {first_name: 'Mac', last_name: 'Stark', Patient: 16, date_of_birth: '24-03-2019', protein: 6, city : "Surat", phoneno : "123456789" , email : "test@test.com"},
    {first_name: 'Deep', last_name: 'Mehra', Patient: 4, date_of_birth: '24-03-2019', protein: 4, city : "Surat", phoneno : "123456789" , email : "test@test.com"},
    {first_name: 'Goerge', last_name: 'Singh', Patient: 16, date_of_birth: '24-03-2019', protein: 4, city : "Surat", phoneno : "123456789" , email : "test@test.com"},
    {first_name: 'Jhon ', last_name: 'Shinah', Patient: 6, date_of_birth: '24-03-2019', protein: 4, city : "Surat", phoneno : "123456789" , email : "test@test.com"},
    {first_name: 'Robort', last_name: 'Pitter', Patient: 9, date_of_birth: '24-03-2019', protein: 4, city : "Surat", phoneno : "123456789" , email : "test@test.com"},
    {first_name: 'Mac', last_name: 'Stark', Patient: 16, date_of_birth: '24-03-2019', protein: 6, city : "Surat", phoneno : "123456789" , email : "test@test.com"},
  ];
  sortedData2: camp[];

  constructor(
    public dialogRef: MatDialogRef<CampDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) 
    {
      this.sortedData2 = this.desserts2.slice();
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

   sortData(sort: Sort) {
    const data = this.desserts2.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData2 = data;
      return;
    }

    this.sortedData2 = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
         
        case 'first_name': return compare(a.first_name, b.first_name, isAsc);
        case 'last_name': return compare(a.last_name, b.last_name, isAsc);
        case 'Patient': return compare(a.Patient, b.Patient, isAsc);
        case 'date_of_birth': return compare(a.date_of_birth, b.date_of_birth, isAsc);
        case 'protein': return compare(a.protein, b.protein, isAsc);
        case 'city': return compare(a.city, b.city, isAsc);
        case 'phoneno': return compare(a.phoneno, b.phoneno, isAsc);
        case 'email': return compare(a.email, b.email, isAsc);
        default: return 0;
      }
    });


}
 
}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
